
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pod",
      function () {
        return require("private-next-pages/pod/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pod"])
      });
    }
  